import * as CapitalMuiTheme_Theme_components_navigation_MuiBreadcrumbs from "./MuiBreadcrumbs.js";
import * as CapitalMuiTheme_Theme_components_navigation_MuiLink from "./MuiLink.js";
import * as CapitalMuiTheme_Theme_components_navigation_MuiTabs from "./MuiTabs.js";
const navigation = {
  ...CapitalMuiTheme_Theme_components_navigation_MuiBreadcrumbs,
  ...CapitalMuiTheme_Theme_components_navigation_MuiLink,
  ...CapitalMuiTheme_Theme_components_navigation_MuiTabs
};
export {
  navigation
};
//# sourceMappingURL=index.js.map
